module.exports = __webpack_public_path__ + "img/speaker.503fafff.jpg";